export default "__VITE_ASSET__BqR059B4__"